<template>
  <div class="card-parcelas-pedido-expedido-faturado">
    <g-card class="card-consultas-carta-header" :temCabecalho="false" :expansivel="false">
      <div class="header-detalhes-secundario">
        <div class="header-detalhes-secundario-titulo">
          <g-button
            class="buscar-button-header"
            largura="35px"
            icone="icone_voltar.svg"
            negritoTexto
            tamanhoIcone="10px"
            cor="#FFFFFF"
            altura="30px"
            :sombreado="false"
            @click="voltar()"
          />
          <div class="titulo-detalhes-cabecalho"> Parcelas do Pedido </div>
        </div>

        <div class="print header-icons" v-tooltip="'Abrir PDF'">
          <g-button
            class=""
            altura="35px"
            largura="35px"
            tamanhoIcone="15px"
            icone="icone_print.svg"
            @click="imprimir()"
          />
        </div>
      </div>

      <div class="grupo-dados-gerais espacamento-detalhes">
        <div class="dados-parcela-titulo titulo-grupo-detalhes"> Dados Gerais </div>

        <div class="grupo-dados-parcela">
          <div class="dados-parcela-pedido">
            <div class="titulo-conteudo-detalhes"> Pedido </div>
            <div class="label-conteudo"> {{this.detalhesDoPedidoFluxo.CodigoExternoPedido}} </div>
          </div>

          <div class="dados-parcela-orcamento">
            <div class="titulo-conteudo-detalhes"> Orçamento </div>
            <div class="label-conteudo"> {{this.detalhesDoPedidoFluxo.CodigoExternoOrcamento}} </div>
          </div>

          <div class="dados-parcela-tipo">
            <div class="titulo-conteudo-detalhes"> Tipo </div>
            <div class="label-conteudo"> {{this.detalhesDoPedidoFluxo.TipoPedidoTexto}} </div>
          </div>

          <div class="dados-parcela-cliente">
            <div class="titulo-conteudo-detalhes"> Cliente / CNPJ </div>
            <div class="label-conteudo"> {{this.detalhesDoPedidoFluxo.CodigoExternoCliente}} - {{this.detalhesDoPedidoFluxo.NomeFantasia}} / {{this.detalhesDoPedidoFluxo.CnpjFormatado }} </div>
          </div>

          <div class="dados-parcela-representante">
            <div class="titulo-conteudo-detalhes"> Representante </div>
            <div class="label-conteudo"> {{this.detalhesDoPedidoFluxo.NomeRepresentante}} </div>
          </div>

          <div class="dados-parcela-unidade">
            <div class="titulo-conteudo-detalhes"> Unidade </div>
            <div class="label-conteudo"> {{this.detalhesDoPedidoFluxo.NomeEmpresa}} </div>
          </div>

          <div class="dados-parcela-cv">
            <div class="titulo-conteudo-detalhes"> CV </div>
            <div class="label-conteudo"> {{this.detalhesDoPedidoFluxo.CurvaClienteTexto}} </div>
          </div>
        </div>
      </div>

      <div class="content-parcelas espacamento-detalhes">
        <div class="titulo-grupo-detalhes"> Parcelas </div>

        <div class="grupo-parcelas">
          <div class="parcelas" v-for="(obj, index) in this.parcelasInfo" :key="index">
            <div class="numero-parcela-botoes">
              <div class="numero-parcela"> {{index + 1}}º Parcela </div>
              <div class="btns-acoes-parcelas">
                <div v-tooltip="'Exibe as notas fiscais relacionadas a esta parcela'">
                  <g-button class="botoes" altura="35px" largura="35px" tamanhoIcone="15px"
                    @Click="notasFiscaisRota()"
                  >
                    <i class="pi pi-file"></i>
                  </g-button>
                </div>

                <div v-tooltip="'Exibe as observações'">
                  <g-button class="botoes" altura="35px" largura="35px" tamanhoIcone="15px"
                    @Click="observacoesRota(obj.id, obj.numeroParcela)"
                  >
                    <i class="pi pi-book"></i>
                  </g-button>

                </div>

                <div v-tooltip="'Exibe as instruções de carregamento'">
                  <g-button class="botoes" altura="35px" largura="35px" tamanhoIcone="15px"
                    @Click="instrucoesCarregamentoRota(obj.id, obj.numeroParcela)"
                  >
                    <i class="pi pi-car"></i>
                  </g-button>

                </div>
                <div v-tooltip="'Exibe o histórico de alterações'">
                  <g-button class="botoes" altura="35px" largura="35px" tamanhoIcone="15px"
                    @Click="historicoRota(obj.id, obj.numeroParcela)"
                  >
                    <i class="pi pi-clock"></i>
                  </g-button>
                </div>
              </div>
            </div>
            
            <div class="conteudo-parcelas">
              <div class="data-carregamento">
                <div class="titulo-conteudo-detalhes"> Data Carregamento </div>
                <div class="label-conteudo">{{ obj.dataCarregamentoFormatada || 'Sem Dados'}}</div>
              </div>

              <div class="quantidade">
                <div class="titulo-conteudo-detalhes"> Quantidade </div>
                <div class="label-conteudo">{{ formataDecimal(obj.quantidadePedidoParcela) }}</div>
              </div>

              <div class="data-conf-carregamento">
                <div class="titulo-conteudo-detalhes"> Data Conf. Carregamento </div>
                <div class="label-conteudo">{{ obj.dataPedidoParcelaFormatada }}</div>
              </div>

              <div class="qtde-produzida">
                <div class="titulo-conteudo-detalhes"> Quantidade Produzida </div>
                <div class="label-conteudo">{{ formataDecimal(obj.quantidadeProduzida) }}</div>
              </div>

              <div class="qtde-expedida">
                <div class="titulo-conteudo-detalhes"> Quantidade Expedida </div>
                <div class="label-conteudo">{{ formataDecimal(obj.quantidadeExpandida) }}</div>
              </div>

              <div class="parcela">
                <div class="titulo-conteudo-detalhes"> Parcela </div>
                <div class="label-conteudo">{{ obj.numeroParcelaDias }}</div>
              </div>

              <div class="agua-liberacao-producao">
                <div class="titulo-conteudo-detalhes"> Aguardando Liberação para Produzir </div>
                <div class="label-conteudo">{{ obj.liberadoParaProduzir == false ? 'Não' : 'Sim' }}</div>
              </div>

              <div class="dias-prorrogados">
                <div class="titulo-conteudo-detalhes"> Dias Prorrogados </div>
                <div class="label-conteudo">{{ obj.numeroParcelaDias }}</div>
              </div>

              <div class="indicador">
                <div class="titulo-conteudo-detalhes"> Indicador </div>
                <div class="label-conteudo">{{ obj.indicadorTexto || '-' }}</div>
              </div>

              <div class="data-base">
                <div class="titulo-conteudo-detalhes"> Data Base </div>
                <div class="label-conteudo">{{ obj.dataBasePedidoParcelaFormatada || '-' }}</div>
              </div>

              <div class="ordem-compra">
                <div class="titulo-conteudo-detalhes"> Ordem de Compra (O.C)</div>
                <div class="label-conteudo">{{ obj.numeroOrdemDeCompra || 'Não Possui' }}</div>
              </div>

              <div class="componente">
                <div class="titulo-conteudo-detalhes"> Componente </div>
                <div class="label-conteudo" v-for="(componente, index) in obj.componentePedidoParcelaArray" :key="index"
                >
                  {{componente.componenteTipoTexto || 'Não Possui'}}
                </div>
              </div>

              <div class="fase-producao">
                <div class="titulo-conteudo-detalhes"> Fase de Produção </div>
                <div class="label-conteudo" v-for="(componente, index) in obj.componentePedidoParcelaArray" :key="index"
                >
                  {{componente.descricaoFaseProduto || 'Não Possui'}}
                </div>
              </div>

              <!-- <div class="fase-producao">
                <div class="titulo-conteudo-detalhes"> Fase de Produção </div>
                <div class="label-conteudo">
                  {{obj.descricaoFaseProduto || 'Não Possui'}}
                </div>
              </div> -->

              <div class="obs-parcelas">
                <div class="titulo-conteudo-detalhes"> Observações sobre as parcelas </div>
                <div class="label-conteudo">{{obj.descricaoParcela || 'Não Possui'}}</div>
              </div>
            </div>
          </div>
        </div>        
      </div>
    </g-card>
  </div>

  <g-pdf :pdfFloat="false" :NovaGuia="true" :executar="executarvisualizacao">
    <div class="render" v-if="renderiza">
      <PedidoEmAndamentoPDF 
        :tituloDetalhes="false" 
        v-on:termino="gerarPdf" 
        :pedidoSelecionado="linhaSelecionada"
        @podeGerarPDF="podeGerarPdf = $event"
      />
    </div>
  </g-pdf>
</template>

<script>
import ParcelasPedidoExpedidosFaturados from './ParcelasPedidoExpedidoFaturado.js'
export default ParcelasPedidoExpedidosFaturados
</script>

<style scoped>
.header-icons-detahes {
  display: flex;
  justify-self: center;
  column-gap: 5px;
}

.header-titulo-voltar {
  width: 100%;
  display: flex;
  align-items: flex-end;
}

.grupo-parcelas {
  margin-top: 1.5rem;
}

.numero-parcela-botoes {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1rem;
}

.btns-acoes-parcelas {
  display: flex;
  align-items: center;
  column-gap: 0.3rem;
}

.conteudo-parcelas {
	padding: 1rem 1.5rem 0.3rem;
	border-radius: 0.5rem;
	background-color: #F9F9F9;
  border-left: 5px solid #e7ae4c98;
	margin-bottom: 3rem;
}

.numero-parcela {
  color: #4D4D4D;
  text-align: justify;
  font-size: 1.1rem;
  font-family: 'MontSerrat';
  font-weight: 600;
}

@media(min-width:310px) {

}

@media(min-width:368px) {

}

@media (min-width:450px) {
.grupo-dados-parcela {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: auto;
  column-gap: 1rem;
  margin-bottom: 1.5rem;
}

.dados-parcela-cliente {
  grid-column: span 2;
}
}

@media(min-width:600px) {
  .grupo-dados-parcela {
    grid-template-columns: repeat(3, 1fr);
  }
  .dados-parcela-cliente {
    grid-column: span 3;
  }
  .dados-parcela-unidade {
    grid-column: span 2;
  }

  .conteudo-parcelas {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.5rem 1rem;
  }

  .obs-parcelas {
    grid-column: span 2;
  }
}

@media(min-width:801px) {
  .dados-parcela-unidade {
    grid-column: span 1;
  }

  .conteudo-parcelas {
    grid-template-columns: repeat(3, 1fr);
  }

  .obs-parcelas {
    grid-column: span 3;
  }
}

@media(min-width:1025px) {
  .grupo-dados-parcela {
    grid-template-columns: repeat(4, 1fr);
  }
  .dados-parcela-cliente {
    grid-column: span 1;
  }
}

@media(min-width:1285px) {}

@media(min-width:1500px) {
  .conteudo-parcelas {
    grid-template-columns: repeat(4, 1fr);
  }

  .obs-parcelas {
    grid-column: span 4;
  }
}

@media(min-width:1800px) {
  .grupo-dados-parcela {
    grid-template-columns: repeat(5, 1fr);
  }
  
  .conteudo-parcelas {
    grid-template-columns: repeat(5, 1fr);
  }

  .obs-parcelas {
    grid-column: span 5;
  }
}
</style>